<!-- 전체 앱 컨테이너 - 반응형 -->
<div class="min-h-screen bg-gray-100 md:bg-white flex flex-col items-center">
  <!-- 모바일: 480px 제한 / PC: 풀 너비 -->
  <div
    class="relative flex h-full w-full max-w-[480px] md:max-w-none flex-col bg-white shadow-xl md:shadow-none min-h-screen">
    <router-outlet />
  </div>
</div>
